module.exports = __webpack_public_path__ + "img/plant_4_mobile_small.7fe26423.webp";